import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { FirebaseNotificationManager } from 'helpers/pushes/FirebaseNotificationManager';
import { useSystemSearchQueries } from 'hooks/useSystemSearchQueries';

import { usePartnerId } from './usePartnerId';

export const useWebPushRetry = () => {
  const history = useHistory();

  const { search } = useLocation();

  const { getPushRetryQuery } = useSystemSearchQueries();
  const { isOrganicPartnerIdOnMainMirror } = usePartnerId();

  const { value: pushRetryQueryValue, key: pushRetryQueryKey } =
    getPushRetryQuery();

  useEffect(() => {
    if (pushRetryQueryValue) {
      const queries = queryString.parse(search);

      delete queries[pushRetryQueryKey];

      history.replace({ search: queryString.stringify(queries) });

      if (!isOrganicPartnerIdOnMainMirror) return;

      FirebaseNotificationManager.requestPushPermissionsAndTrack();
    }
  }, [
    history,
    isOrganicPartnerIdOnMainMirror,
    pushRetryQueryKey,
    pushRetryQueryValue,
    search,
  ]);
};
